import { Injectable } from "@angular/core";
import { IUseCase } from "@karma-games/angular-devkit/src/lib/interfaces";
import { Observable } from "rxjs";
import { RoundRepository } from "../../core/round/round.repository";

@Injectable()
export class GetBetActionInProgressUseCase implements IUseCase<number, Observable<boolean>> {
    constructor(private roundRepository: RoundRepository) {
    }

    execute(betIndex: number): Observable<boolean> {
        return this.roundRepository.subscribeBetActionInProgress(betIndex);
    }
}
